import Joi from 'joi';
import { objectId } from '@/shared/validations/custom.validation';
import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { InvoiceSettings } from './invoiceSettings.model';

export const getInvoiceSettings = {
  query: Joi.object().keys({
    companyId: Joi.string().custom(objectId).required(),
  }),
};

export const upsertInvoiceSettings = () => ({
  body: generateJoiValidation(InvoiceSettings.schema, true),
});
